/** Pure helpers for the Threads tab of the v2 community page. */

export interface ThreadSummary {
  message: any;
  replies: number;
  lastAt: number;
  lastBy: string;
  lastTime: string;
}

/** Messages that have at least one thread reply, most recent reply first. */
export function activeThreads(messages: any[]): ThreadSummary[] {
  return (messages || [])
    .filter(m => m?.threadReplies?.length > 0)
    .map(m => {
      const last = m.threadReplies[m.threadReplies.length - 1];
      return {
        message: m,
        replies: m.threadReplies.length,
        lastAt: Number(last?.timestamp) || 0,
        lastBy: last?._sender?.nickname || '',
        lastTime: last?.msgTime && last.msgTime !== 'Invalid Date' ? last.msgTime : '',
      };
    })
    .sort((a, b) => b.lastAt - a.lastAt);
}

const FILE_LABEL: Record<string, string> = { image: 'Photo', video: 'Video', audio: 'Audio' };

/** One-line preview of a thread's first message. */
export function threadPreview(message: any): string {
  if (!message) return '';
  if (message.isBlocked) return 'This message has been blocked';
  if (message.type === 'poll') return `Poll: ${message.question || ''}`.trim();
  const text = String(message.message || '').trim().split('\n')[0];
  if (text) return text.length > 80 ? text.slice(0, 79) + '…' : text;
  const file = message.files?.[0];
  return file ? FILE_LABEL[file.type] || file.name || 'File' : '';
}
